if (!customElements.get('jr-hero-slider')) {
  customElements.define('jr-hero-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.controller = new AbortController();
      const on = (target, event, handler) => target?.addEventListener(event, handler, { signal: this.controller.signal });
      on(this.querySelector('[data-prev]'), 'click', () => this.move(-1));
      on(this.querySelector('[data-next]'), 'click', () => this.move(1));
      on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => this.schedule());
      on(this, 'focusout', () => setTimeout(() => this.isConnected && this.schedule(), 0));
      on(document, 'visibilitychange', () => this.schedule());
      on(document, 'shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); }
      });
      this.show(0);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    move(delta) {
      const next = this.index + delta;
      if (this.dataset.loop === 'true') this.show((next + this.slides.length) % this.slides.length);
      else this.show(Math.max(0, Math.min(this.slides.length - 1, next)));
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.hidden = false;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      const loop = this.dataset.loop === 'true';
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (prev) prev.disabled = !loop && index === 0;
      if (next) next.disabled = !loop && index === this.slides.length - 1;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.paused || this.hovered || document.hidden || this.contains(document.activeElement) || matchMedia('(prefers-reduced-motion: reduce)').matches || (this.dataset.loop !== 'true' && this.index === this.slides.length - 1)) return;
      this.timer = setTimeout(() => this.move(1), Number(this.dataset.interval) || 5000);
    }
  });
}
